import { Modal } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import Captcha from "../../../screens/BuscarInfracciones/Captcha";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import MapaDePuntos from "../../../screens/MapaDePuntos";
import { format, parseISO } from "date-fns";

const ModalMapaDePuntos = (props) => {
  const { camaras, setCamaras } = props;

  //? ESTADOS GLOBALES
  const { alertasBloqueo, alertasNoBloqueo } = useActaDetalleStore();
  const { modals, handlerModal } = useGeneralAppStore();

  return (
    <>
      <Modal
        show={modals.includes("mapa_de_puntos")}
        size={"fullscreen"}
        onHide={() => handlerModal({ modal: false, modalName: "mapa_de_puntos" })}
        title={() =>
          "Mapa" +
          (camaras.filtrar_por_fecha && camaras.fecha_inicio && camaras.fecha_fin 
            ? ` - ${format(parseISO(camaras.fecha_inicio), "dd/MM/yyyy")} - ${format(parseISO(camaras.fecha_fin), "dd/MM/yyyy")}`
            : "")
        }
      >
        <MapaDePuntos camaras={camaras} setCamaras={setCamaras} />
      </Modal>
    </>
  );
};
export default ModalMapaDePuntos;
